import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { VerifyOtpDialogComponent } from '../verify-otp-dialog/verify-otp-dialog.component';
import { UserService } from '@app-services/user/user.service';
import { SignupService } from '@app-services/signup/signup.service';
import { TenantConstant } from '@app-constants/tenant.constant';
import { GAnalyticsService } from '@app-services/g-analytics/g-analytics.service';
import { BoardsService } from '@app-services/boarrds/boards.service';
import { NavigationExtras, Router } from '@angular/router';
import { openTermsAndConditionsDialog } from '@app-core/components/home/home.component';
import { states } from '@app-constants/subscriptionconstants';
import { NgxSpinnerService } from 'ngx-spinner';
import { apisDataCacheKeys, examDisplayNames } from '@app-constants/app.constants';
import { TestlistService } from '@app-services/test/testlist.service';
import { ScheduleService } from '@app-services/schedule/schedule.service';
import { CommunicationMessageService } from '@app-services/communication-message/communication-message.service';
import { registerNow } from 'src/app/helpers/methods';

const srcMessages = {
  'JEE': {
    Testseries: 'JEE Test Series',
    Liveclasses: 'JEE Live Classes',
    Mocktest: 'JEE Mock Tests',
    pyps: 'JEE Previous Year Papers',
    default: 'JEE Live Classes',
    Specialseries: 'JEE Special Test Series',
  },
  'NEET': {
    Testseries: 'Neet Test Series',
    Liveclasses: 'Neet Live Course',
    Specialseries: 'NEET Special Test Series',
    default: 'Neet Live Course'
  }
}

@Component({
  selector: 'app-testseries-dialog',
  templateUrl: './testseries-dialog.component.html',
  styleUrls: ['./testseries-dialog.component.css']
})
export class TestseriesDialogComponent implements OnInit {
  states: any = states;
  grades: any = [];
  exams: any = [];
  displayedExams: any = [];
  streams: any = [];
  tenant: any = TenantConstant.tenant;
  signupForm!: FormGroup;
  dialogConfigData: any;
  phoneNumber: any = "";
  registrationErrorMessage: any = '';
  srcMessage: any = "";
  leadCreated: boolean;
  isJEE: boolean;
  dataFetched: boolean = false;
  hiddenFields: any = {};
  formErrorExists: boolean = false;
  disabledFields: any = {};
  openTermsAndConditionsDialog = openTermsAndConditionsDialog;
  constructor(public signUpService: SignupService,
    private SignupService: SignupService,
    public router: Router,
    private dialog: MatDialog,
    private _formBuilder: FormBuilder,
    private gaService: GAnalyticsService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private gradesService: BoardsService,
    private userService: UserService,
    private dialogRef: MatDialogRef<TestseriesDialogComponent>,
    private spinner: NgxSpinnerService, 
    private testListService: TestlistService,
    private scheduleService: ScheduleService,
    private communicationMessageService: CommunicationMessageService,) {
    dialogRef.disableClose = true;
  }

  ngOnInit(): void {
    this.spinner.show();
    this.dialogRef.disableClose = true;
    this.dialogConfigData = this.data;
    this.isJEE = this.data.isJEE == true ? true : false;
    this.hiddenFields = this.data.hiddenFields != undefined ?this.data.hiddenFields: {hallticket: true, exam: true, state: true};
    this.disabledFields = this.data.disabledFields != undefined ?this.data.disabledFields: {source: true};
    this.disabledFields.phone = !!this.data?.phone;
    this.disabledFields.grade = !!this.data?.grade;
    this.disabledFields.exam = !!this.data?.exam;
    if(this.data?.ILITE) {
      this.srcMessage = 'ILITE Test';
    } else if(this.data?.REPEATER) {
      this.srcMessage = 'Repeater course';
    }
    else if (this.isJEE) {
      this.srcMessage = srcMessages['JEE'][this.data?.source] || srcMessages['JEE'].default;
    } else {
      this.srcMessage = srcMessages['NEET'][this.data?.source] || srcMessages['NEET'].default
    }

    if (this.tenant != 'srichaitanya') {
      //@ts-ignore
      Promise.all([this.gradesService.getGrades(this), this.gradesService.getTargetExams(this), this.gradesService.getStreams(this)]).then(() => {
        if(['9th', '10th', '11th'].indexOf(this.data?.grade?.toLowerCase()) > -1 ) {
          this.displayedExams = this.exams.filter(e => {
            return ['NEET', 'JEEMAIN'].indexOf(e.name.replaceAll(" ", "").toUpperCase()) > -1;
          })
        } 
        this.createSignUpForm();
        this.spinner.hide();
      })
    }
  }

  createSignUpForm(): void {
    const grp = {
      phone: [{value: this.data.phone, disabled: this
        .disabledFields?.phone}, [Validators.required, Validators.pattern(/[6-9][0-9]{9}/)]],
      firstname: ['', [Validators.required]],
      lastname: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.email, Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\\.[a-zA-Z]{2,4}$')]],
      source: [{value: this.srcMessage, disabled: this.disabledFields?.source}, [Validators.required]],
      grade: [{value: this.data?.grade || '', disabled:this.disabledFields?.grade} , [Validators.required]], //change disabled pattern later
      whatsappConsent: [true, [Validators.required]],
      valid: true,
    };
      
    if (!this?.hiddenFields.hallticket) {
      grp['hallticket'] = [''];
    }
    if (!this?.hiddenFields.exam) {
      grp['exam'] = [{value: (this.data?.exam?.replaceAll(" ", "").toUpperCase() || ''), disabled: !this.data?.REPEATER}, [Validators.required]];
    }
    if (!this?.hiddenFields.state) {
      grp['state'] = [{value: '', disabled: false}, [Validators.required]];
    }
    this.signupForm = this._formBuilder.group(grp);
    if(!this.hiddenFields?.exam) {
      this.displayedExams = this.exams;
      this.signupForm.controls.grade.valueChanges.subscribe(v => {
        this.signupForm.controls.exam.enable();
        if(['9th', '10th', '11th'].indexOf(v?.toLowerCase()) > -1 ) {
          this.displayedExams = this.exams.filter(e => {
            return ['NEET', 'JEEMAIN','CBSE'].indexOf(e.name.replaceAll(" ", "").toUpperCase()) > -1;
          })
          if(!this.displayedExams.some(e => {
            return this.signupForm.controls.exam.value == e.name;
          })) {
            this.signupForm.get('exam')?.setValue('');
          }
        } else {
           this.displayedExams = this.exams.filter(e => (!(v=='13th' && (e.name == 'CBSE' || e.name == 'Foundation Test' || e.name == 'Aptitude Test')) && 
                                                           !(v=='12th' && (e.name == 'Foundation Test' || e.name == 'Aptitude Test'))))
          }
      })
    }
  }

  get s() { 
    //@ts-ignore
    return this.signupForm.controls; 
  }

  enterKey(event: any): void {
    if (event.keyCode === 13) {
      this.next();
    }
  }

  checkbox(): any {
    this.signupForm.get('whatsappConsent')?.setValue(this.signupForm?.value?.whatsappConsent ? true : false)
  }

  next(): void {
    this.signupForm.markAllAsTouched();
    this.formErrorExists = false;
    if (!this.signupForm.valid) {
      this.formErrorExists = true;
      return;
    }
    if (this.tenant != 'srichaitanya') {
      if (this.signupForm.valid) {
        const formVal = this.signupForm.getRawValue()
        let body = {
          firstName: formVal.firstname,
          lastName: formVal.lastname,
          phone: formVal.phone,
          whatsappConsent: formVal.whatsappConsent,
          valid: formVal.valid
        }
        if (!this?.hiddenFields.hallticket) {
          body['hallticket'] = formVal.hallticket;
        }
        this.register(body, this.data.countryCode)
      }
    } else {
      this.submitData({});
    }
  }

  register(formValue: any, countryCode: string): any {
    console.log(formValue);
    this.signUpService.generateOtp(formValue, countryCode).subscribe((data: any) => {
      if (data) {
        this.gaService.sendEvent('formSubmit', 'signup_data', 'signup_data',
          'signup/login', formValue)
        //this.dialogRef.close();
        this.openOTPVerificationPopup();
      } else { this.signupForm.get('phone')?.setValue(this.phoneNumber); }
    },
      (error) => {                                     // on error
        this.signupForm.get('phone')?.setValue(this.phoneNumber);
        if (error.error && error.error.message) {
          this.registrationErrorMessage = error.error.message
        } else {
          this.registrationErrorMessage = "Server error"
        }
        console.log(error);
      });
  }

  openOTPVerificationPopup(): void {
    const formVal = this.signupForm.getRawValue();
    const config: MatDialogConfig = {
      width: '450px',
      data: {
        message: 'Verify OTP',
        message2: "Please verify the OTP sent to " + this.dialogConfigData.countryCode + " " + formVal.phone,
        totalData: formVal,
        countryCode: this.dialogConfigData.countryCode,
        phone: formVal.phone,
        actionData: this.data?.actionData,
        isFormSubmit: true,
      },
      autoFocus: true
    };

    const dialogRef = this.dialog.open(VerifyOtpDialogComponent, config);
    dialogRef.afterClosed().subscribe((value) => {
      if (value) {
        this.spinner.show();
        this.submitData(value)
      }
    });
  }
  
  submitData(value) {
    this.signupForm.markAllAsTouched()
    if (!this.signupForm.valid)  return;
    const formVal = this.signupForm.getRawValue();
    let ex1 = "NEET";
    let ex2 = "NEET";
    if(!this.hiddenFields.exam) 
    {
      ex1 = ex2 = formVal.exam?.replaceAll(" ", "").toUpperCase();
    } else if(this.isJEE) {
      ex1 = "JEEMAIN";
      ex2 = "JEEADVANCED";
    }
    makeLSQReq.call(this, 
      { value, 
        needPayment: this.data.needPayment,
        reset: () => { this.signupForm.reset(); }, 
        formVal, 
        ex1, ex2, streamName: "PCB", source: this.srcMessage, 
        cb: (waitForUserDataUpdate, userDataUpdated, leadCreated, needPayment) => 
          { 
            this.navigateToDashboard(waitForUserDataUpdate, userDataUpdated, leadCreated, needPayment, formVal); 
          } 
      }
    );
  }

  navigateToDashboard(waitForUserDataUpdate: any, userDataUpdated: any, leadCreated: any, needPayment: any, formVal: any) {
    if(this.data?.ILITE) {
      
      let user = JSON.parse(localStorage.getItem(apisDataCacheKeys.userDetails));
      this.gaService.sendEvent(
        `User Signup For Exam`, 
        `ILITE_page`, 
        `User Signup For Exam`,  
        `ILITE_page`,  
        {
          'event': 'User Signup For Exam',
          'Phone Number': user.phone,
          'First Name': user.firstName,
          'Last Name': user.lastName,
          'City': '',
          'Email ID': user.email,
          'Test Name': "ILITE test",
          'User Id': user.userId,
          'Current_Grade': `${user?.grade.name}`,
          'Select_Exam': `${user?.exams && user?.exams[0].name}`,
          'Whatsapp_Consent': user?.whatsappConsent
        }
      );
    }
    if (this.tenant != 'srichaitanya') {
      if ((!waitForUserDataUpdate || userDataUpdated) && leadCreated) {
        localStorage.setItem("targetExamName", this.isJEE ? "JEEADVANCED": formVal?.exam);
        localStorage.setItem('SelectedTab', this?.data?.source == 'Liveclasses' ? 'liveclass' : 'assessment');

        const navExtras = { ...this.data, ...formVal, detailsEntered: true };
        const navigationExtras: NavigationExtras = {
          state: navExtras 
        };
        if(needPayment || this.data?.ILITEDirect) {
          let selectedState;
          if(!this.hiddenFields.state) {
            selectedState = this.states.find(s => s.abbreviation == formVal.state);
          }
          navExtras.selectedState = selectedState;
          navExtras.examtype = "SCHOLARSHIPTEST"; //make this dynamic, later
          if(this.data?.ILITEDirect) {
            this.dialogRef.close(navExtras);
          } else {
            this.dialogRef.close();
            this.router.navigate(['/congratulations'], navigationExtras).then(() => this.spinner.hide());  
          }
        } else {
          if(this.data?.REPEATER) {
            navExtras.source = 'Repeater course for '+ examDisplayNames[formVal.exam] + ' for 2022';
          }
          this.dialogRef.close();
          this.router.navigate(['/thankyou'], navigationExtras).then(() => this.spinner.hide());
        }
      }
    }
  }

  keyEscape(event: any) {
    if (event.key === 'Escape') {
      this.dialogRef.close();
    }

    if (event.keyCode === 13) {
      document.getElementById('RegisterAndVerify')?.focus()
    }
  }

  closeDialogue() {
    this.dialogRef.close();
  }
}

export function constructLSQReqBody(formVal: any, source: any) {
  let body = [];
  body.push({ Attribute: 'FullName', Value: formVal.firstname + " " + formVal.lastname });
  body.push({ Attribute: 'EmailAddress', Value: formVal.email });
  body.push({ Attribute: 'Phone', Value: formVal.phone });
  body.push({ Attribute: 'SearchBy', Value: 'Phone' });
  body.push({ Attribute: 'is_whatsapp_concerned', Value: formVal.whatsappConsent ? "YES" : "NO" });
  body.push({ Attribute: 'grade', Value: formVal.grade });
  body.push({ Attribute: 'timestamp', Value: (new Date().toLocaleDateString()) + ' ' + (new Date().toLocaleTimeString("en-IN")) });
  body.push({ Attribute: 'source', Value: source });
  if (source == 'Special Test Series') {
    //body.push({ Attribute: 'Neet hall ticket number', Value: formVal.hallticket })
  } else if(source.toLowerCase().indexOf("ilite") > -1) {
    body.push({ Attribute: 'Exam', Value: formVal.exam })
    body.push({ Attribute: 'State', Value: formVal.state })
  } else if(source.toLowerCase().indexOf("repeater") > -1) {
    body.push({ Attribute: 'Exam', Value: formVal.exam })
  }
  return body;
}

export function makeLSQReq(ipObj: any) {
  let { value, reset, formVal, ex1, ex2, streamName, source, cb, needPayment = false } = ipObj;
  let waitForUserDataUpdate = false, userDataUpdated, leadCreated;
  if (this.tenant != 'srichaitanya') {
    if (value && value.userDto) {
      let userData = JSON.parse(JSON.stringify(value.userDto));
      if ((!userData?.grade || needPayment || (this.disabledFields && this.disabledFields?.grade)) && this.grades) {
        this.grades.some(element => {
          if (element.name == (formVal.grade + "th") || element.name == formVal.grade) {
            userData.grade = element;
            return waitForUserDataUpdate = true;
          }
        });
      }

      if ((!value.userDto?.exams || needPayment || (this.disabledFields && this.disabledFields?.exam)) && this.exams) {
        this.exams.some(element => {
          const elName = element.name.replaceAll(" ", "").toUpperCase();
          if (elName == ex1 || elName == ex2) {//"NEET"
            userData.exams = [element];
            return waitForUserDataUpdate = true;
          }
        });
      }

      if (!value.userDto?.stream && this.streams) {
        this.streams.some(element => {
          if (element.name == streamName) {//"PCB"
            userData.stream = element;
            return waitForUserDataUpdate = true;
          }
        });
      }

      if (!value.userDto?.email) {
        userData.email = formVal.email;
        waitForUserDataUpdate = true;
      }

      if (!value.userDto?.firstName) {
        userData.firstName = formVal.firstname;
        waitForUserDataUpdate = true;
      }

      if (!value.userDto?.lastName) {
        userData.lastName = formVal.lastname;
        waitForUserDataUpdate = true;
      }

      if ((!value.userDto?.whatsappConsent && formVal.whatsappConsent) ||
        (value.userDto?.whatsappConsent && !formVal.whatsappConsent)
      ) {
        userData.whatsappConsent = formVal.whatsappConsent;
        waitForUserDataUpdate = true;
      }

      if (waitForUserDataUpdate) {
        this.userService.updateUserDetails(userData).subscribe((data: any) => {
          let gradeByName = data?.userDto?.grade?.name?.replace('st', '')?.replace('nd', '')?.replace('rd', '')?.replace('th', '');
          this.userService.setMobileAndName({
            phone: data.userDto.phone, isdCode: data.userDto.isdCode, firstName: data.userDto.firstName, lastName: data.userDto.lastName,
            whatsappConsent: data.userDto.whatsappConsent, userId: data.userDto.userId, profilePhoto: data.userDto.profilePhoto, grade: Number(gradeByName)
          });
          this.userService.updateRequestedUserData(data.userDto);
          userDataUpdated = true;
          cb(waitForUserDataUpdate, userDataUpdated, leadCreated, needPayment);
        },
          (error: any) => {                                     // on error
            userDataUpdated = true;
            //alert(error.error.message);
            cb(waitForUserDataUpdate, userDataUpdated, leadCreated, needPayment);
          });
      }
    }
  }
  if(this.data?.ILITE) {
    const tsBody = {
      "examtype": [
        "SCHOLARSHIPTEST"
      ],
      "coursetype": [
        formVal?.exam
      ],
      "classes": [
        formVal?.grade
      ]
    }
    
    this.testListService.getPreviousAndPresentMockTests(tsBody).subscribe(async (overallTests: any) => {
      if(overallTests?.length) {
        let en = formVal?.exam == "JEEADVANCED" ? "39694": formVal?.exam;
        let t = overallTests.find(e => {
          return e.className == formVal?.grade && e.examtype == "SCHOLARSHIPTEST" &&  e.coursetype?.replaceAll(" ", "")?.toUpperCase() == en;
        })
        if(t) {
          registerNow.call(this, [t],  "SCHOLARSHIPTEST", false).then(() => {
            let p = LSQPOST.call(this, {...ipObj, waitForUserDataUpdate, userDataUpdated });      
            p.finally(() => {
              if (this.tenant == 'srichaitanya' && this.dialogRef) this.dialogRef.close();
              leadCreated = true;
              cb(waitForUserDataUpdate, userDataUpdated, leadCreated, needPayment);
            })
          }, (error) => {
            console.log('error: ', error);
          this.spinner.hide();
          alert("Sever error. Please try again");  
          });
          
          return;
        }
      } 
        
        let body = new FormData()
        body.append('user_id', value?.userDto?.userId)
        body.append('mobile', formVal.phone)
        body.append('whatsapp_consent', formVal.whatsappConsent ? "YES" : "NO")
        body.append('grade', formVal.grade);
        body.append('timestamp', (new Date().toLocaleDateString()) + ' ' + (new Date().toLocaleTimeString("en-IN")))
        body.append('exam', formVal.exam);
        body.append('examtype', "SCHOLARSHIPTEST");
        let linkSource = formVal.exam + ( formVal.grade == '11th' || formVal.grade == '12th' ? "_11_12": "_9_10_13" )
        this.SignupService.signupDataToGSheets(body, linkSource).then((response: any) => {
          let p = LSQPOST.call(this, {...ipObj, waitForUserDataUpdate, userDataUpdated });      
          p.finally(() => {
            if (this.tenant == 'srichaitanya' && this.dialogRef) this.dialogRef.close();
            leadCreated = true;
            cb(waitForUserDataUpdate, userDataUpdated, leadCreated, needPayment);
          })
        }).catch((error: any) => {
          console.log('error: ', error);
          this.spinner.hide();
          alert("Sever error. Please try again");
        })      
    }, (err) => {
      console.log('error: ', err);
          this.spinner.hide();
          alert("Sever error. Please try again");
    }); 
  } else {
    let p = LSQPOST.call(this, {...ipObj, waitForUserDataUpdate, userDataUpdated });
    p.finally(() => {
      if (this.tenant == 'srichaitanya' && this.dialogRef) this.dialogRef.close();
      leadCreated = true;
      cb(waitForUserDataUpdate, userDataUpdated, leadCreated, needPayment);
    })
  }   
  
}

function LSQPOST(inp: any) {
  let { value, reset, formVal, ex1, ex2, streamName, source, cb, needPayment = false, waitForUserDataUpdate, userDataUpdated } = inp;
  let leadCreated;
  let p = new Promise((rs, rj) => {
    const _body = constructLSQReqBody(formVal, source);
    this.SignupService.leadSquaredJee(_body).then((response) => {
      rs("LSQ_success");
    }, (error) => {
      rj("LSQ_failed");
    })
  })
  
  return p;
}